import type { InvoiceDefaults } from '@/components/finance/ClientInvoiceSettings';

export interface ContractRecord {
  id: string; number: string | null; title: string | null; service_type: string; status: string;
  account_id: string; account?: { id: string; name: string } | null; deal_id?: string | null; deal?: { id: string; title: string } | null;
  start_date: string; duration_months: number; end_date: string; renewal_date: string | null; reminder_days: number; signed_date: string | null;
  value: string | null; currency: string; billing_cycle: string; auto_renew: boolean; is_expiring_soon: boolean;
  terms: string | null; notes: string | null; periods_missing?: number; renewal_of?: { id: string; number: string } | null;
  billing_mode: 'fixed' | 'variable' | 'percentage'; deliverables: Array<Record<string, unknown>>; invoice_settings: InvoiceDefaults;
  income_start_invoice_id?: string | null; ignored_periods?: string[];
  contract_billed_total?: string; invoiced_total?: string; invoices_count?: number;
  can?: { update: boolean; delete: boolean } | null;
}
export interface RenewalTerm { id: string; number: string; start_date: string; end_date: string; status: string }
export interface BillingPeriod {
  period_start: string; period_end: string; status: string;
  invoice: { id: string; invoice_number: string; amount: string; currency: string; status: string; is_ignored?: boolean } | null;
}
export const CONTRACT_STATUS: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700', active: 'bg-green-100 text-green-800', ended: 'bg-gray-100 text-gray-600', cancelled: 'bg-red-100 text-red-800',
  renewed: 'bg-purple-100 text-purple-800', expired: 'bg-orange-100 text-orange-800',
};
